import { render } from "./AboutChabotView.vue?vue&type=template&id=1aa38909"
import script from "./AboutChabotView.vue?vue&type=script&lang=js"
export * from "./AboutChabotView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__